import { useNavigate } from 'react-router-dom';

export function NotFoundPage() {
	const navigate = useNavigate();

	return (
		<main className="error-page-container relative grid min-h-[100dvh] w-full min-w-0 place-items-center overflow-hidden px-4 text-center sm:px-6">
			<div className="absolute bottom-8 left-4 w-24 sm:left-10 sm:w-32 md:left-40" aria-hidden="true">
				<img className="h-auto max-w-full" alt="" src="https://futurelab.global/images/mars.svg" />
			</div>
			<div className="relative z-10 flex flex-col items-center">
				<div className="mt-24 flex max-w-full items-center text-white sm:mt-32">
					<span className="flex items-center font-sans text-[6rem] font-black leading-none text-[#71b4dc] [-webkit-text-stroke:2px_black] sm:text-[7rem] md:text-[11rem] md:[-webkit-text-stroke:4px_black]">
						4
						<img alt="Earth" className="mb-4 inline h-auto w-20 sm:mb-6 sm:w-24 md:mb-8 md:w-44" src="https://futurelab.global/images/earth.svg" />
						4
					</span>
				</div>
				<h1 className="text-xl font-semibold tracking-widest text-white sm:text-2xl">PAGE NOT FOUND</h1>
				<button
					className="mt-6 text-lg text-white underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
					onClick={() => navigate('/')}
					type="button"
				>
					Go to Home Page
				</button>
			</div>
			<div className="flying-astronaut max-w-[40vw]" aria-hidden="true">
				<img className="h-auto max-w-full" alt="" src="https://futurelab.global/images/flying_astronaut.svg" />
			</div>
		</main>
	);
}
